module.exports = __webpack_public_path__ + "assets/img/newlogin1.7c0b26c9.png";